import EmptyView from "@/views/webViews/components/EmptyView.vue"; // 空页面
export default [
  {
    path: "/",
    name: "Index",
    component: () => import("../views/webViews/HomeIndex.vue"), //主页
    redirect: "/index/homePage",
  },
  {
    path: "/index",
    name: "HomeIndex",
    component: () => import("../views/webViews/HomeIndex.vue"), // 主页
    redirect: "/index/homePage",
    children: [
      {
        path: "/index/homePage",
        name: "homePage",
        component: () => import("../views/webViews/views/homePage.vue"), // 首页
      },
      {
        path: "/index/aboutAcademy",
        name: "aboutAcademy",
        component: () =>
          import("../views/webViews/views/aboutAcademy/index.vue"), // 关于研究院
        meta: { title: "关于研究院" },
        redirect: "/index/aboutAcademy/index",
        children: [
          {
            path: "/index/aboutAcademy/index",
            component: () =>
              import("../views/webViews/views/aboutAcademy/default.vue"), // 院况介绍
            meta: { title: "院况介绍" },
          },
          {
            path: "/index/aboutAcademy/talentPool",
            name: "aboutAcademyTalentPool",
            component: () =>
              import("../views/webViews/views/aboutAcademy/talentPool.vue"), // 人才队伍
            meta: { title: "人才队伍" },
          },
          {
            path: "/index/aboutAcademy/talentPool/detail",
            name: "aboutAcademyTalentPoolDetail",
            component: () =>
              import("../views/webViews/views/aboutAcademy/detail.vue"), // 人才队伍详情
            meta: { title: "人才队伍详情" },
          },
        ],
      },
      {
        path: "/index/scientificResearch",
        name: "scientificResearch",
        component: () =>
          import("../views/webViews/views/scientificResearch/index.vue"), // 科学研究
        meta: { title: "科学研究" },
        redirect: "/index/scientificResearch/researchProgress",
        children: [
          {
            path: "/index/scientificResearch/researchProgress",
            name: "researchProgress",
            component: () =>
              import(
                "../views/webViews/views/scientificResearch/researchProgress/index.vue"
              ), // 科研进展
            meta: { title: "科研进展" },
          },
          {
            path: "/index/scientificResearch/researchProgress/detail",
            name: "researchProgressDetail",
            component: () =>
              import(
                "../views/webViews/views/scientificResearch/researchProgress/detail.vue"
              ), // 科研进展详情
            meta: { title: "科研进展详情" },
          },
          {
            path: "/index/scientificResearch/academicExchange",
            name: "academicExchange",
            component: () =>
              import(
                "../views/webViews/views/scientificResearch/academicExchange/index.vue"
              ), // 学术交流
            meta: { title: "学术交流" },
          },
          {
            path: "/index/scientificResearch/academicExchange/detail",
            name: "academicExchangeDetail",
            component: () =>
              import(
                "../views/webViews/views/scientificResearch/academicExchange/detail.vue"
              ), // 学术交流详情
            meta: { title: "学术交流详情" },
          },
          {
            path: "/index/scientificResearch/majorPlatforms",
            name: "majorPlatforms",
            component: () =>
              import(
                "../views/webViews/views/scientificResearch/majorPlatforms/index.vue"
              ), // 重大平台
            meta: { title: "重大平台" },
          },
          {
            path: "/index/scientificResearch/majorPlatforms/detail",
            name: "majorPlatformsDetail",
            component: () =>
              import(
                "../views/webViews/views/scientificResearch/majorPlatforms/detail.vue"
              ), // 重大平台详情
            meta: { title: "重大平台详情" },
          },
          {
            path: "/index/scientificResearch/learnBuild",
            name: "learnBuild",
            component: () =>
              import(
                "../views/webViews/views/scientificResearch/learnBuild/index.vue"
              ), // 学会建设
            meta: { title: "学会建设" },
          },
          {
            path: "/index/scientificResearch/learnBuild/detail",
            name: "learnBuildDetail",
            component: () =>
              import(
                "../views/webViews/views/scientificResearch/learnBuild/detail.vue"
              ), // 学会建设详情
            meta: { title: "学会建设详情" },
          },
        ],
      },
      {
        path: "/index/achievementTransformation",
        name: "achievementTransformation",
        // component: RouterView,
        // component: () =>
        //   import("../views/webViews/views/achievementTransformation/index.vue"), // 成果转化
        // component: () =>
        //   import("../views/webViews/views/achievementTransformation/default.vue"), // 成果转化
        // meta: { title: "成果转化" },
        redirect: "/index/achievementTransformation/index",
        children: [
          {
            path: "/index/achievementTransformation/index",
            component: () =>
              import(
                "../views/webViews/views/achievementTransformation/default.vue"
              ), // 成果转化
            meta: { title: "成果转化" },
          },
          {
            path: "/index/achievementTransformation/transformInnovation",
            name: "transformInnovation",
            component: () =>
              import(
                "../views/webViews/views/achievementTransformation/transformInnovation/index.vue"
              ), // 转化创新
            meta: { title: "转化创新" },
          },
          {
            path: "/index/achievementTransformation/transformInnovation/detail",
            name: "transformInnovationDetail",
            component: () =>
              import(
                "../views/webViews/views/achievementTransformation/transformInnovation/detail.vue"
              ), // 转化创新详情
            meta: { title: "转化创新详情" },
          },
          {
            path: "/index/achievementTransformation/achievementPromotion",
            name: "achievementPromotion",
            component: () =>
              import(
                "../views/webViews/views/achievementTransformation/achievementPromotion/index.vue"
              ), // 成果推广
            meta: { title: "成果推广" },
          },
          {
            path: "/index/achievementTransformation/achievementPromotion/detail",
            name: "achievementPromotionDetail",
            component: () =>
              import(
                "../views/webViews/views/achievementTransformation/achievementPromotion/detail.vue"
              ), // 成果推广详情
            meta: { title: "成果推广详情" },
          },
          {
            path: "/index/achievementTransformation/publicServicePlatform",
            name: "publicServicePlatform",
            component: () =>
              import(
                "../views/webViews/views/achievementTransformation/publicServicePlatform/index.vue"
              ), // 公共服务平台
            meta: { title: "公共服务平台" },
          },
        ],
      },

      {
        path: "/index/keyLaboratory",
        name: "keyLaboratory",
        component: () =>
          import("../views/webViews/views/keyLaboratory/index.vue"), // 重点实验室
        meta: { title: "重点实验室" },
        redirect: "/index/keyLaboratory/overview",
        children: [
          {
            path: "/index/keyLaboratory/overview",
            name: "overview",
            component: () =>
              import(
                "../views/webViews/views/keyLaboratory/overview/index.vue"
              ), // 实验室概况
            meta: { title: "实验室概况" },
          },
          {
            path: "/index/keyLaboratory/researchTteam/index",
            name: "researchTteamIndex",
            component: () =>
              import(
                "../views/webViews/views/keyLaboratory/researchTteam/index.vue"
              ), // 研究队伍
            meta: { title: "研究队伍" },
          },
          {
            path: "/index/keyLaboratory/researchTteam/detail",
            name: "researchTteamDetail",
            component: () =>
              import(
                "../views/webViews/views/keyLaboratory/researchTteam/detail.vue"
              ), // 研究队伍详情
            meta: { title: "研究队伍详情" },
          },
          {
            path: "/index/keyLaboratory/organizationManage/index",
            name: "organizationManageIndex",
            component: () =>
              import(
                "../views/webViews/views/keyLaboratory/organizationManage/index.vue"
              ), // 实验室动态
            meta: { title: "实验室动态" },
          },
          {
            path: "/index/keyLaboratory/organizationManage/detail",
            name: "organizationManageDetail",
            component: () =>
              import(
                "../views/webViews/views/keyLaboratory/organizationManage/detail.vue"
              ), // 实验室动态详情
            meta: { title: "实验室动态详情" },
          },
        ],
      },

      {
        path: "/index/cooperationExchange",
        name: "cooperationExchange",
        component: () =>
          import("../views/webViews/views/cooperationExchange/index.vue"), // 合作交流
        meta: { title: "合作交流" },
        redirect: "/index/cooperationExchange/exchangeDynamics",
        children: [
          {
            path: "/index/cooperationExchange/exchangeDynamics",
            name: "exchangeDynamics",
            component: () =>
              import(
                "../views/webViews/views/cooperationExchange/exchangeDynamics/index.vue"
              ), // 交流动态
            meta: { title: "交流动态" },
          },
          {
            path: "/index/cooperationExchange/exchangeDynamics/detail",
            name: "exchangeDynamicsDetail",
            component: () =>
              import(
                "../views/webViews/views/cooperationExchange/exchangeDynamics/detail.vue"
              ), // 交流动态详情
            meta: { title: "交流动态详情" },
          },
          {
            path: "/index/cooperationExchange/cooperationPartner",
            name: "cooperationPartner",
            component: () =>
              import(
                "../views/webViews/views/cooperationExchange/cooperationPartner/index.vue"
              ), // 合作伙伴
            meta: { title: "合作伙伴" },
          },
          {
            path: "/index/cooperationExchange/cooperationPartner/detail",
            name: "cooperationPartnerDetail",
            component: () =>
              import(
                "../views/webViews/views/cooperationExchange/cooperationPartner/detail.vue"
              ), // 合作伙伴
            meta: { title: "校地合作详情" },
          },
        ],
      },
      {
        path: "/index/leadersCare",
        name: "leadersCare",
        component: () =>
          import("../views/webViews/views/leadersCare/index.vue"), // 领导关心
        meta: { title: "领导关心" },
        redirect: "/index/leadersCare/index",
        children: [
          {
            path: "/index/leadersCare/index",
            component: () =>
              import("../views/webViews/views/leadersCare/default.vue"), // 领导关心
            meta: { title: "领导关心" },
          },
          {
            path: "/index/leadersCare/detail",
            name: "leadersCareDetail",
            component: () =>
              import("../views/webViews/views/leadersCare/detail.vue"), // 领导关心详情
            meta: { title: "领导关心详情" },
          },
        ],
      },
      {
        path: "/index/newsAndActivities",
        name: "newsAndActivities",
        component: EmptyView, // 新闻与活动
        meta: { title: "新闻与活动" },
        redirect: "/index/newsAndActivities/newsCenter",
        children: [
          {
            path: "/index/newsAndActivities/newsCenter",
            name: "newsCenter",
            component: EmptyView, // 新闻中心
            meta: { title: "新闻动态", keepAlive: true },
            redirect: "/index/newsAndActivities/newsCenter/list",
            children: [
              {
                path: "/index/newsAndActivities/newsCenter/list",
                name: "newsCenter-list",
                component: () =>
                  import(
                    "../views/webViews/views/newsAndActivities/newsCenter/home.vue"
                  ), // 新闻列表
                meta: { title: "新闻动态", keepAlive: true },
              },
              {
                path: "/index/newsAndActivities/newsCenter/detail",
                name: "newsCenter-detail",
                component: () =>
                  import(
                    "../views/webViews/views/newsAndActivities/newsCenter/detail.vue"
                  ), // 新闻详情
                meta: { title: "新闻详情", keepAlive: false },
              },
            ],
          },
          {
            path: "/index/newsAndActivities/businessWindow",
            name: "businessWindow",
            component: EmptyView, // 新闻中心
            meta: { title: "商务之窗", keepAlive: true },
            redirect: "/index/newsAndActivities/businessWindow/list",
            children: [
              {
                path: "/index/newsAndActivities/businessWindow/list",
                name: "businessWindow-list",
                component: () =>
                  import(
                    "../views/webViews/views/newsAndActivities/businessWindow/home.vue"
                  ), // 商务之窗列表
                meta: { title: "商务之窗", keepAlive: true },
              },
              {
                path: "/index/newsAndActivities/businessWindow/detail",
                name: "businessWindow-detail",
                component: () =>
                  import(
                    "../views/webViews/views/newsAndActivities/businessWindow/detail.vue"
                  ), // 商务之窗详情
                meta: { title: "商务之窗详情", keepAlive: false },
              },
            ],
          },
          {
            path: "/index/newsAndActivities/peopleTrain",
            name: "peopleTrain",
            component: EmptyView, // 临床培训
            meta: { title: "临床培训（人）" },
            redirect: "/index/newsAndActivities/peopleTrain/list",
            children: [
              {
                path: "/index/newsAndActivities/peopleTrain/list",
                name: "peopleTrain-peopleTrainList",
                component: () =>
                  import(
                    "../views/webViews/views/newsAndActivities/peopleTrain/list.vue"
                  ), // 临床培训
              },
              {
                path: "/index/newsAndActivities/peopleTrain/detail",
                name: "peopleTrain-detail",
                component: () =>
                  import(
                    "../views/webViews/views/newsAndActivities/peopleTrain/detail.vue"
                  ), // 临床培训详情
              },
            ],
          },
          {
            path: "/index/newsAndActivities/petTrain",
            name: "petTrain",
            component: EmptyView, // 临床培训
            meta: { title: "临床培训（宠）" },
            redirect: "/index/newsAndActivities/petTrain/list",
            children: [
              {
                path: "/index/newsAndActivities/petTrain/list",
                name: "petTrain-petTrainList",
                component: () =>
                  import(
                    "../views/webViews/views/newsAndActivities/petTrain/list.vue"
                  ), // 临床培训
              },
              {
                path: "/index/newsAndActivities/petTrain/detail",
                name: "petTrain-detail",
                component: () =>
                  import(
                    "../views/webViews/views/newsAndActivities/petTrain/detail.vue"
                  ), // 临床培训详情
              },
            ],
          },
          {
            path: "/index/newsAndActivities/activitiesAnnouncement",
            name: "activitiesAnnouncement",
            component: EmptyView, // 活动公告
            meta: { title: "活动", keepAlive: true },
            redirect: "/index/newsAndActivities/activitiesAnnouncement/list",
            children: [
              {
                path: "/index/newsAndActivities/activitiesAnnouncement/list",
                name: "activitiesAnnouncement-list",
                component: () =>
                  import(
                    "../views/webViews/views/newsAndActivities/activitiesAnnouncement/list.vue"
                  ), // 活动公告列表
                meta: { title: "活动公告", keepAlive: true },
              },
              {
                path: "/index/newsAndActivities/activitiesAnnouncement/detail",
                name: "activitiesAnnouncement-detail",
                component: () =>
                  import(
                    "../views/webViews/views/newsAndActivities/activitiesAnnouncement/detail.vue"
                  ), // 活动公告详情
                meta: { title: "活动公告详情", keepAlive: false },
              },
            ],
          },
        ],
      },
      //   -------------------------------------------   教育教学
      {
        path: "/index/teachingManagement",
        name: "teachingManagement",
        component: () =>
          import("../views/webViews/views/teachingManagement/index.vue"), // 首页
        meta: { title: "教育教学" },
        redirect: "/index/teachingManagement/teachHome",
        children: [
          {
            path: "/index/teachingManagement/teachHome",
            name: "teachHome",
            component: () =>
              import(
                "../views/webViews/views/teachingManagement/childrenPage/homePage.vue"
              ), // 首页
            meta: { title: "首页" },
          },
          {
            path: "/index/teachingManagement/teacherTeam",
            name: "teacherTeam",
            component: () =>
              import(
                "../views/webViews/views/teachingManagement/childrenPage/teacherTeam.vue"
              ), // 师资队伍
            meta: { title: "师资队伍" },
          },
          {
            path: "/index/teachingManagement/teacherTeamDetail",
            name: "teacherTeamDetail",
            component: () =>
              import(
                "../views/webViews/views/teachingManagement/childrenPage/teacherTeamDetail.vue"
              ), // 师资队伍详情
            meta: { title: "师资队伍" },
          },

          {
            path: "/index/teachingManagement/talentCultivate",
            name: "talentCultivate",
            component: () =>
              import(
                "../views/webViews/views/teachingManagement/childrenPage/talentCultivate.vue"
              ), // 人才培养
            meta: { title: "人才培养" },
          },
          {
            path: "/index/teachingManagement/studentWork",
            name: "studentWork",
            component: () =>
              import(
                "../views/webViews/views/teachingManagement/childrenPage/studentWork.vue"
              ), // 学生工作
            meta: { title: "学生工作" },
          },
          {
            path: "/index/teachingManagement/recruitmentAndEmployment",
            name: "recruitmentAndEmployment",
            component: () =>
              import(
                "../views/webViews/views/teachingManagement/childrenPage/recruitmentAndEmployment.vue"
              ), // 招生就业
            meta: { title: "招生就业" },
          },
          /*{
            path: "/index/teachingManagement/teacherDetail",//培养管理详情-导师详情
            name: "teacherDetail",
            component: () =>
                import(
                    "../views/webViews/views/teachingManagement/teacherDetail.vue"
                    ), // 培养管理详情
            meta: { title: "师资队伍详情" },
          },
          {
            path: "/index/teachingManagement/trainingManagementDetail",//培养管理详情
            name: "trainingManagementDetail",
            component: () =>
              import(
                "../views/webViews/views/teachingManagement/trainingManagementDetail.vue"
              ), // 培养管理详情
            meta: { title: "培养管理" },
          },
          {
            path: "/index/teachingManagement/studentWork",
            name: "studentWork",
            component: () =>
              import(
                "../views/webViews/views/teachingManagement/studentWork.vue"
              ), // 学生工作
            meta: { title: "学生工作" },
          },
          {
            path: "/index/teachingManagement/studentActivitiesDetail",
            name: "studentActivitiesDetail",
            component: () =>
                import(
                    "../views/webViews/views/teachingManagement/studentActivitiesDetail.vue"
                    ), // 学生工作详情
            meta: { title: "学生活动详情" },
          },
          {
            path: "/index/teachingManagement/studentRegulationsDetail",
            name: "studentRegulationsDetail",
            component: () =>
                import(
                    "../views/webViews/views/teachingManagement/studentRegulationsDetail.vue"
                    ), // 规章制度详情
            meta: { title: "规章制度详情" },
          },
          {
            path: "/index/teachingManagement/recruitmentAndEmployment",
            name: "recruitmentAndEmployment",
            component: () =>
              import(
                "../views/webViews/views/teachingManagement/recruitmentAndEmployment.vue"
              ), // 招生就业
            meta: { title: "招生就业" },
          },
          {
            path: "/index/teachingManagement/recruitmentAndEmploymentDetail", //招生或就业信息详情页
            name: "recruitmentAndEmploymentDetail",
            component: () =>
              import(
                "../views/webViews/views/teachingManagement/recruitmentAndEmploymentDetail.vue"
              ), // 信息下载
            meta: { title: "招生就业信息" },
          },
          {
            path: "/index/teachingManagement/downloadCenter",
            name: "downloadCenter",
            component: () =>
              import(
                "../views/webViews/views/teachingManagement/downloadCenter.vue"
              ), // 下载中心
            meta: { title: "下载中心" },
          },
          {
            path: "/index/teachingManagement/downloadCenterDetail",
            name: "downloadCenterDetail",
            component: () =>
              import(
                "../views/webViews/views/teachingManagement/downloadCenterDetail.vue"
              ), // 下载中心详情
            meta: { title: "下载中心详情" },
          },
          {
            path: "/index/teachingManagement/clubActivities",
            name: "clubActivities",
            component: () =>
              import(
                "../views/webViews/views/teachingManagement/clubActivities.vue"
              ), // 社团活动
            meta: { title: "社团活动" },
          },
          {
            path: "/index/teachingManagement/clubActivitiesDetail",//社团活动详情
            name: "clubActivitiesDetail",
            component: () =>
              import(
                "../views/webViews/views/teachingManagement/clubActivitiesDetail.vue"
              ), // 社团活动详情
            meta: { title: "社团活动" },
          },*/
        ],
      },
      {
        path: "/index/teachingManagement/teachingManageDetail",
        name: "teachingManageDetail",
        component: () =>
          import(
            "../views/webViews/views/teachingManagement/childrenPage/teachingManageDetail.vue"
          ), // 教育教学详情
        meta: { title: "教育教学详情" },
      },
      {
        path: "/index/talentRecruitment",
        component: EmptyView,
        // component: () =>
        //   import("../views/webViews/views/talentRecruitment/index.vue"), // 人才招聘
        name: "talentRecruitment",
        meta: { title: "人才招聘" },
        redirect: "/index/talentRecruitment/noticeRecruitment",
        children: [
          {
            path: "/index/talentRecruitment/noticeRecruitment",
            name: "noticeRecruitment",
            component: () =>
              import("../views/webViews/views/talentRecruitment/notice.vue"), // 招聘公告
            meta: { title: "招聘公告" },
          },
          {
            path: "/index/talentRecruitment/noticeRecruitmentDetail",
            name: "noticeRecruitmentDetail",
            component: () =>
              import(
                "../views/webViews/views/talentRecruitment/noticeRecruitmentDetail.vue"
              ), // 招聘公告详情
            meta: { title: "招聘公告详情" },
          },
          {
            path: "/index/talentRecruitment/jobInformation",
            name: "jobInformation",
            component: () =>
              import(
                "../views/webViews/views/talentRecruitment/jobInformation.vue"
              ), // 岗位信息
            meta: { title: "岗位信息" },
          },
          {
            path: "/index/talentRecruitment/jobInformationDetail",
            name: "jobInformationDetail",
            component: () =>
              import(
                "../views/webViews/views/talentRecruitment/jobInformationDetail.vue"
              ), // 岗位信息详情
            meta: { title: "岗位信息详情" },
          },
          {
            path: "/index/talentRecruitment/workingEnvironment",
            name: "workingEnvironment",
            component: () =>
              import(
                "../views/webViews/views/talentRecruitment/workingEnvironment.vue"
              ), // 工作环境
            meta: { title: "工作环境" },
          },
          /*{
            path: "/index/talentRecruitment/welfarePolicy",
            name: "welfarePolicy",
            component: () =>
              import(
                "../views/webViews/views/talentRecruitment/welfarePolicy.vue"
              ), // 福利政策
            meta: { title: "福利政策" },
          },
          {
            path: "/index/talentRecruitment/welfarePolicyDetail",
            name: "welfarePolicyDetail",
            component: () =>
              import(
                "../views/webViews/views/talentRecruitment/welfarePolicyDetail.vue"
              ), // 福利政策详情
            meta: { title: "福利政策详情" },
          },*/
        ],
      },
      {
        path: "/index/talentRecruitment/recruitmentDetail",
        name: "recruitmentDetail",
        component: () =>
          import(
            "../views/webViews/views/talentRecruitment/recruitmentDetail.vue"
          ), // 招聘详情
        meta: { title: "招聘详情" },
      },
      {
        path: "/index/partyMassWork",
        name: "partyMassWork",
        meta: { title: "党群工作" },
        redirect: "/index/partyMassWork/partyMassIndex",
        children: [
          {
            path: "/index/partyMassWork/partyMassIndex",
            name: "partyMassIndex",
            component: () =>
              import(
                "../views/webViews/views/partyMassWork/partyMassActivity.vue"
              ), // 首页
            meta: { title: "首页" },
          },
          {
            path: "/index/partyMassWork/partyMassOrganizations",
            name: "partyMassOrganizations",
            component: () =>
              import(
                "../views/webViews/views/partyMassWork/partyMassActivity.vue"
              ), // 组织构成
            meta: { title: "组织构成" },
          },
          {
            path: "/index/partyMassWork/partyMassActivity/workActivity",
            name: "workActivity",
            component: () =>
              import(
                "../views/webViews/views/partyMassWork/partyMassActivity.vue"
              ), // 工作动态
            meta: { title: "工作动态" },
          },
          {
            path: "/index/partyMassWork/partyMassActivity/studyActivity",
            name: "studyActivity",
            component: () =>
              import(
                "../views/webViews/views/partyMassWork/partyMassActivity.vue"
              ), // 学习之窗
            meta: { title: "学习之窗" },
          },

          {
            path: "/index/partyMassWork/partyMassActivity/partyMassActivityDetail",
            name: "partyMassActivityDetail",
            component: () =>
              import(
                "../views/webViews/views/partyMassWork/partyMassActivityDetail.vue"
              ), // 党群动态详情
            meta: { title: "党群工作详情" },
          },
        ],
      },
      {
        path: "/index/searchResult",
        name: "contactUs",
        component: EmptyView, // 联系我们
        meta: { title: "搜索" },
        redirect: "/index/searchResult/list",
        children: [
          {
            path: "/index/searchResult/list",
            name: "contactUsHome",
            component: () =>
              import("../views/webViews/views/searchResult/list.vue"), // 联系我们
            meta: { title: "搜索" },
          },
        ],
      },
    ],
  },
  {
    path: "/index/outlink",
    name: "Outlink",
    component: () => import("../views/webViews/Outlink.vue"), // 外部链接
    meta: { title: "外部链接" },
  }
];